import React from 'react';
import { JumbotronPropTypes } from './JumbotronPropTypes';
import { CallToActionButton } from '../ctaButton';

export const CTAButton = ({ ctaButtonConfig, breakpoints }: JumbotronPropTypes.IButtons) => {
  const buttons = ctaButtonConfig.map((config, index) => {
    return <CallToActionButton {...config} key={index} otherButtonProps={{ width: breakpoints }} />;
  });

  return buttons;
};
